import { render } from "./BlockModal.vue?vue&type=template&id=40696747&ts=true"
import script from "./BlockModal.vue?vue&type=script&lang=ts"
export * from "./BlockModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__